/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbDemandeApprenantGridDto } from './FcbDemandeApprenantGridDto';
import {
    FcbDemandeApprenantGridDtoFromJSON,
    FcbDemandeApprenantGridDtoFromJSONTyped,
    FcbDemandeApprenantGridDtoToJSON,
} from './FcbDemandeApprenantGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbDemandeApprenantGridDtoPaginatedResults
 */
export interface FcbDemandeApprenantGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbDemandeApprenantGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbDemandeApprenantGridDto>}
     * @memberof FcbDemandeApprenantGridDtoPaginatedResults
     */
    results?: Array<FcbDemandeApprenantGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbDemandeApprenantGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbDemandeApprenantGridDtoPaginatedResults interface.
 */
export function instanceOfFcbDemandeApprenantGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbDemandeApprenantGridDtoPaginatedResultsFromJSON(json: any): FcbDemandeApprenantGridDtoPaginatedResults {
    return FcbDemandeApprenantGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbDemandeApprenantGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbDemandeApprenantGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbDemandeApprenantGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbDemandeApprenantGridDtoPaginatedResultsToJSON(value?: FcbDemandeApprenantGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbDemandeApprenantGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

